export const API = {
	locker_monitor: "v1/website/global/locker/monitor/inactive",
	package_pickup_code_resend: "v1/website/operator/package/pickup/code/resend",
	package_recipient_change: "v1/website/operator/package/recipient/change",
	user_customer_service_code_send:
		"v1/website/operator/user/customer-service/code/send",
	user_message_broadcast: "v1/website/operator/user/message/broadcast",
	user_profile_id_accept: "v1/website/operator/user/profile/id/accept",
	user_profile_id_reject: "v1/website/operator/user/profile/id/reject",
	package_camera_snapshot: "v1/website/operator/package/camera/snapshot",
	camera_snapshot_email: "v1/website/operator/package/camera/snapshot/email",
	package_state_search: "v1/website/operator/package/state/search",
	pullout_api: "v1/website/operator/package/pullout/request/send",
	url_upload_Image: "v1/website/operator/agent/profile/id/upload",
	url_get_image: "v1/website/operator/agent/profile/id/get",
	url_send_sms: "v1/website/operator/user/message/broadcast/sms",
	url_send_app: "v1/website/operator/user/message/broadcast",
	url_send_email: "v1/website/operator/user/message/broadcast/email",
	broadcast_agent:"v1/website/operator/agent/message/broadcast"
};
